import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const billingRequirementsAdapter = getAdapter({ idFieldName: 'value' });

const billingRequirementsSlice = createSlice({
  name: 'billingRequirements',
  initialState: billingRequirementsAdapter.getInitialState(),
  reducers: {
    setBillingRequirements: (state, { payload: { billingRequirements } }) => {
      billingRequirementsAdapter.setAll(state, billingRequirements);
    },
  },
});

const selectors = billingRequirementsAdapter.getSelectors(({ billingRequirements }) => billingRequirements);

export const getBillingRequirements = (state) => selectors.selectAll(state);

export const { setBillingRequirements } = billingRequirementsSlice.actions;

export default billingRequirementsSlice.reducer;
